document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', () => form.querySelector('button[type="submit"]')?.classList.add('is-loading'));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-product-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const current = gallery.querySelector('[data-gallery-current]');
    const viewport = gallery.querySelector('.product-gallery__viewport');
    const lightbox = gallery.querySelector('[data-product-lightbox]');
    const lightboxDialog = lightbox?.querySelector('.product-lightbox__dialog');
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    const lightboxCurrent = lightbox?.querySelector('[data-lightbox-current]');
    const lightboxStage = lightbox?.querySelector('.product-lightbox__stage');
    let lightboxReturnFocus = null;
    let lightboxTouchStartX = null;
    let activeIndex = Math.max(slides.findIndex((slide) => !slide.hidden), 0);

    const updateLightbox = () => {
      if (!lightboxImage || !slides.length) return;

      const activeSlide = slides[activeIndex];
      const previewImage = activeSlide.querySelector('img');
      lightboxImage.src = activeSlide.dataset.fullImageUrl || previewImage?.currentSrc || previewImage?.src || '';
      lightboxImage.alt = previewImage?.alt || '';
      if (lightboxCurrent) lightboxCurrent.textContent = String(activeIndex + 1);
    };

    const syncVariantToMedia = (mediaId) => {
      if (!mediaId) return;

      const variantSelect = gallery.closest('.product-page')?.querySelector('.product-form select[name="id"]');
      if (!variantSelect) return;

      const matchingOptions = [...variantSelect.options].filter((option) => option.dataset.mediaId === String(mediaId));
      if (!matchingOptions.length || matchingOptions.includes(variantSelect.selectedOptions[0])) return;

      const matchingOption = matchingOptions.find((option) => !option.disabled) || matchingOptions[0];
      variantSelect.value = matchingOption.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const showSlide = (nextIndex, syncVariant = true) => {
      if (!slides.length) return;
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });
      thumbs.forEach((thumb, index) => {
        const isActive = index === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
      if (current) current.textContent = String(activeIndex + 1);
      if (syncVariant) syncVariantToMedia(slides[activeIndex].dataset.mediaId);
      if (lightbox && !lightbox.hidden) updateLightbox();
    };

    const openLightbox = (trigger) => {
      if (!lightbox || !lightboxDialog) return;
      lightboxReturnFocus = trigger;
      lightbox.hidden = false;
      document.body.classList.add('product-lightbox-open');
      updateLightbox();
      lightboxDialog.focus();
    };

    const closeLightbox = () => {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.classList.remove('product-lightbox-open');
      lightboxImage?.removeAttribute('src');
      const activeZoomButton = slides[activeIndex]?.querySelector('[data-gallery-zoom]');
      (activeZoomButton || lightboxReturnFocus)?.focus();
      lightboxReturnFocus = null;
    };

    if (current) current.textContent = String(activeIndex + 1);

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.index))));
    gallery.querySelectorAll('[data-gallery-zoom]').forEach((button) => {
      button.addEventListener('click', () => openLightbox(button));
    });
    viewport?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    lightbox?.querySelectorAll('[data-lightbox-close]').forEach((button) => {
      button.addEventListener('click', closeLightbox);
    });
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightboxDialog || event.target === lightboxStage) closeLightbox();
    });
    lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));

    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(activeIndex - 1);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + 1);
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = [...lightbox.querySelectorAll('button:not([hidden]):not([disabled])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === lightboxDialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    lightboxStage?.addEventListener('touchstart', (event) => {
      lightboxTouchStartX = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    lightboxStage?.addEventListener('touchend', (event) => {
      if (lightboxTouchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? lightboxTouchStartX) - lightboxTouchStartX;
      lightboxTouchStartX = null;
      if (Math.abs(distance) < 45) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    gallery.addEventListener('gallery:select-media', (event) => {
      const requestedMediaId = String(event.detail?.mediaId || '');
      const matchingIndex = slides.findIndex((slide) => slide.dataset.mediaId === requestedMediaId);

      if (matchingIndex >= 0) {
        showSlide(matchingIndex, false);
        return;
      }

      const fallbackSlide = slides.find((slide) => slide.hasAttribute('data-variant-fallback'));
      const fallbackImage = fallbackSlide?.querySelector('img');
      if (fallbackImage && event.detail?.imageUrl) {
        fallbackImage.src = event.detail.imageUrl;
        fallbackImage.removeAttribute('srcset');
        fallbackImage.removeAttribute('sizes');
        fallbackImage.alt = event.detail.imageAlt || '';
        if (event.detail.fullImageUrl) fallbackSlide.dataset.fullImageUrl = event.detail.fullImageUrl;
        showSlide(Number(fallbackSlide.dataset.index || 0), false);
      }
    });
  });

  document.querySelectorAll('.product-page').forEach((productPage) => {
    const variantSelect = productPage.querySelector('.product-form select[name="id"]');
    const price = productPage.querySelector('[data-product-price]');
    const addToCart = productPage.querySelector('[data-add-to-cart]');
    const gallery = productPage.querySelector('[data-product-gallery]');

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const available = option.dataset.available === 'true';

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (addToCart) {
        addToCart.disabled = !available;
        addToCart.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
      }

      gallery?.dispatchEvent(new CustomEvent('gallery:select-media', {
        detail: {
          mediaId: option.dataset.mediaId,
          imageUrl: option.dataset.imageUrl,
          fullImageUrl: option.dataset.fullImageUrl,
          imageAlt: option.dataset.imageAlt
        }
      }));

      const productUrl = new URL(window.location.href);
      productUrl.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', productUrl);
    });
  });

  const closeDesktopSubmenu = (item, returnFocus = false) => {
    const toggle = item?.querySelector('[data-submenu-toggle]');
    item?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    const label = toggle?.querySelector('[data-submenu-label]');
    if (label) label.textContent = label.textContent.replace('schließen', 'öffnen');
    if (returnFocus) toggle?.focus();
  };

  document.querySelectorAll('[data-submenu-toggle]').forEach((toggle) => {
    const item = toggle.closest('[data-submenu-item]');

    toggle.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      document.querySelectorAll('[data-submenu-item].is-open').forEach((openItem) => closeDesktopSubmenu(openItem));
      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      const label = toggle.querySelector('[data-submenu-label]');
      if (label) label.textContent = label.textContent.replace(willOpen ? 'öffnen' : 'schließen', willOpen ? 'schließen' : 'öffnen');
    });

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) closeDesktopSubmenu(item);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openItem = document.querySelector('[data-submenu-item].is-open');
    if (openItem) closeDesktopSubmenu(openItem, true);
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-submenu-item].is-open').forEach((item) => {
      if (!item.contains(event.target)) closeDesktopSubmenu(item);
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach((sortSelect) => {
    sortSelect.addEventListener('change', () => sortSelect.form?.requestSubmit());
  });

  document.querySelectorAll('.collection-filter-drawer').forEach((drawer) => {
    const summary = drawer.querySelector('summary');

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) {
        drawer.removeAttribute('open');
        summary?.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (drawer.open && !drawer.contains(event.target)) drawer.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const summary = menu.querySelector('summary');
    const links = menu.querySelectorAll('a');

    links.forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.removeAttribute('open');
        summary?.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  const submittedFormStatus = [...document.querySelectorAll('[data-form-status]')]
    .find((status) => status.textContent.trim().length > 0);
  submittedFormStatus?.focus();
});
